// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/api_limits/company_sdk_rate_limit_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiLimitsCompanySdkRateLimitDatatable } from "./constants";
import type {
  AppsApiLimitsCompanySdkRateLimitDatatableParams,
  AppsApiLimitsCompanySdkRateLimitDatatableResult,
} from "./types";

export const getDataTableAppsApiLimitsCompanySdkRateLimitDatatable = reactQueryTableFetcherAdapter(
  appsApiLimitsCompanySdkRateLimitDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppsApiLimitsCompanySdkRateLimitDatatableParams
  ): Promise<AppsApiLimitsCompanySdkRateLimitDatatableResult> => {
    return fetch(
      "/apps/api_limits/company_sdk_rate_limit_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
